
import BaseService from "./BaseService";

export class DrivingConditionService extends BaseService {
  static getAll() {
    return this.get("/cfadminsysmaintain/api/v1/driving-conditions");
  }

  static create(data: any) {
    return this.post("/cfadminsysmaintain/api/v1/driving-conditions", data);
  }

  static update(id: any, data: any) {
    return this.put("/cfadminsysmaintain/api/v1/driving-conditions", id, data);
  }

  static delete(id: any) {
    return super.delete("/cfadminsysmaintain/api/v1/driving-conditions", id);
  }
}

export default DrivingConditionService;